export enum SeatState {
    Reserved = 'reserved',
    Desired = 'desired',
    Free = 'free',
    Blocked = 'blocked',
}
